import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Flex, FlexItem, Icon, Small } from "orcs-design-system";
import useWorkspaceDateFormats from "src/hooks/useWorkspaceDateFormats";

const HistoryRecord = ({ content, icon, timestamp }) => {
  const { readable: dateFormat } = useWorkspaceDateFormats();
  const recordDate = moment(timestamp);

  return (
    <Flex alignItems="center" gap="s">
      <Icon icon={icon} />
      <Flex alignItems="center" flex="1 1 auto" flexWrap="wrap">
        <FlexItem flex="1 1 auto" mr="s">
          {content}
        </FlexItem>
        <FlexItem flex="0 0 auto">
          <Small fontStyle="italic" ml="auto" color="greyDark">
            {recordDate.fromNow()} - {recordDate.format(dateFormat)}
          </Small>
        </FlexItem>
      </Flex>
    </Flex>
  );
};

HistoryRecord.propTypes = {
  content: PropTypes.node,
  timestamp: PropTypes.string,
  icon: PropTypes.array,
};

export default React.memo(HistoryRecord);
